import { type FC } from 'react'
import classNames from 'classnames'
import { Icon, type IIconProps } from 'shared/ui/Icon'
import { type ITypographyProps, Typography } from 'shared/ui/Typography'
import { Box } from 'shared/ui/Box'
import styles from './styles.module.scss'

type IChoiceTileProps = {
  iconProps: IIconProps
  title: string
  value: string
  checked: boolean
  setChoiceTile: (value: string) => void
  description?: string
  isSimleIcon?: boolean
  titleProps?: ITypographyProps
  className?: string
  disabled?: boolean
}

export const ChoiceTile: FC<IChoiceTileProps> = ({
  iconProps,
  title,
  value,
  checked,
  setChoiceTile,
  description,
  isSimleIcon = false,
  titleProps,
  className,
  disabled,
}) => {
  return (
    <button
      className={classNames(
        styles.wrap,
        {
          [styles.checked]: checked,
          [styles.disabled]: disabled,
        },
        className
      )}
      onClick={() => {
        if (disabled) return
        setChoiceTile(value)
      }}
    >
      <div className={isSimleIcon ? styles.simpleIconWrap : styles.iconWrap}>
        <Icon {...iconProps} />
      </div>
      <Box display='flex' flexDirection='column' gap='4px'>
        <Typography ariaLabel='ChoiceTile' variant='body-md-regular' {...titleProps}>
          {title}
        </Typography>
        {description && (
          <Typography
            ariaLabel='ChoiceTileDescription'
            variant='body-md-regular'
            color={
              disabled ? 'var(--content-primary-disabled)' : 'var(--content-primary-secondary)'
            }
          >
            {description}
          </Typography>
        )}
      </Box>
    </button>
  )
}
